import { render, staticRenderFns } from "./MinimalInformationCampaign.vue?vue&type=template&id=51f20e2c&"
import script from "./MinimalInformationCampaign.vue?vue&type=script&lang=js&"
export * from "./MinimalInformationCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports